import React from 'react';
import { Card } from '@one-thd/sui-atomic-components';
import { useImpression } from '@thd-olt-component-react/impression';
import { SubscriptionsText } from './SubscriptionsText';
import proptypes from 'prop-types';
import classNames from 'classnames';

const SubscriptionsFallback = ({ entryId, hideOutline }) => {
  const subscriptionsImage = 'https://dam.thdstatic.com/content/production/cj67U6r-FDISkAoDDaXiHA/'
  + 'LK2I_pIddi2Y9BVVVJjLJA/optimizedFile/2024_Hero1_Subscription_Service_Terms_Conditions_v2.jpg';
  const bulletPoints = [
    'Save 5% on every eligible subscription item',
    'Set it and forget it with automatic deliveries',
    'Modify or cancel subscriptions anytime'
  ];

  const { ref, clickID } = useImpression({
    data: {
      id: entryId || '',
      name: 'BuyAgainFallback',
      component: 'BuyAgain',
      position: 1,
      type: 'content'
    }
  });

  return (
    <Card
      data-component="BuyAgainSubscriptionsFallback"
      data-testid="buy-again-subscriptions-fallback"
      className={classNames('sui-h-full sui-@container', { 'sui-border-0': hideOutline })}
      CardContentProps={{
        className: 'sui-flex sui-flex-col-reverse @3xl:sui-flex-row sui-w-full sui-gap-6 sui-p-4 sui-justify-between'
      }}
      ref={ref}
      clickid={clickID}
    >
      <SubscriptionsText/> 
      <div
        className={classNames(
          'sui-w-full sui-max-h-64 sui-overflow-hidden',
          '@3xl:sui-max-h-[100%] @3xl:sui-min-w-[33%] @3xl:sui-max-w-[50%]',
          '@5xl:sui-max-w-[40%]'
        )}
      >
        <img
          src={subscriptionsImage}
          className="sui-h-full sui-w-full sui-object-cover"
          alt="subscriptionsImage"
        />
      </div>
    </Card>
  );
};

SubscriptionsFallback.propTypes = {
  entryId: proptypes.string,
  hideOutline: proptypes.bool
};

SubscriptionsFallback.defaultProps = {
  entryId: null,
  hideOutline: false
};

export { SubscriptionsFallback };